module.exports = __webpack_public_path__ + "img/7_204.b6f4bffa.png";